import React, { useEffect, useState } from "react";
import { getMerchant } from '../../helpers/ReduxHelpers';
import { apiConstants, getGeneric, postGeneric } from '../../common/constants';
import { useForm } from "react-hook-form";
import { Box, Button, FormControlLabel, Grid, Switch, Tooltip, Typography } from "@mui/material";
import { FormProvider, RHFDateTimeField, RHFTextField } from "../../common/hook-form";
import { LoadingButton } from "@mui/lab";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from 'yup'
import Loader from "../../common/Loader"
import { useSnackbar } from "notistack";
import ProzoDataGrid from "../../common/ProzoDataGrid";
import ConfirmDialog from "../../common/ConfirmDialog";
import { parseTime2 } from "../../helpers/UtilityHelper";
import { primaryBtnSx, filterBarSx } from '../../styles/patterns';
import { FONT, SIZE, WEIGHT } from '../../styles/foundation/typography';
import { NAVY, SUBTLE } from '../../styles/foundation/colors';
import { primaryTextSx, cellStackSx } from '../orders/list2/cellStyles';

const NDREmailConfig = () => {
    // const userToken = jwt_decode(getToken());
    // // const merchantId = (userToken && userToken.merchantOid) ? userToken.merchantOid : "";
    // const { merchant } = useSelector((state) => state.user.userInfo);
    // const merchantId =
    //     merchant?.id || (userToken && userToken.merchantOid ? userToken.merchantOid : "");

    const merchant = getMerchant();
    const merchantId = merchant.id ? merchant.id : ''


    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [ndrConfig, setNDRConfig] = useState();
    const [isNDRDailyEnabled, setIsNDRDailyEnabled] = useState(false);
    const [isNDREnabled, setNDREnabled] = useState(false);
    const [reload, setReload] = useState(0);
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const [deleteData, setDeleteData] = useState();
    const [switchConfirm, setSwitchConfirm] = useState({ open: false, type: null });
    const [sizePerPage, setSizePerPage] = useState(10);
    const [page, setPage] = useState(0);
    const [timeVal, setTimeVal] = useState('');

    const columns = [
        {
            field: 'emails',
            headerAlign: "left",
            hideSortIcons: true,
            headerName: 'Emails',
            flex: 1.2,
            minWidth: 250,
            align: 'left',
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}><Typography sx={primaryTextSx}>{row?.email}</Typography></Box>
                )
            },
        },
        {
            field: 'action',
            headerAlign: "left",
            hideSortIcons: true,
            headerName: 'Action',
            flex: 0.5,
            minWidth: 120,
            align: 'left',
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Button
                        onClick={() => handleCancelOrder(row)}
                        disabled={!isNDREnabled}
                        color="error"
                        variant="outlined"
                        size="small"
                    >
                        Delete
                    </Button>

                );
            },
        },
    ];

    const emailListRegExp = /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,}\s*,\s*)*[\w+-.%]+@[\w-.]+\.[A-Za-z]{2,}$/
    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                email: Yup.string()
                    .matches(emailListRegExp, { message: 'Invalid email format', excludeEmptyString: true })
                    .required("Email is required!"),
            })
        ),
        defaultValues: {
            email: '',
        }
    })
    const { handleSubmit: handleSubmitForm, reset } = methods

    const postNDRConfigUpdate = (payload) => {
        postGeneric(`${apiConstants.UPDATE_NDR_EMAIL_CONFIG}`, payload).then(response => {
            enqueueSnackbar('Success', { variant: 'success' })
            reset()
            setReload(reload => reload + 1)
            setLoading(false)
        })
            .catch((err) => {
                console.error(err)
                enqueueSnackbar('Some error occurred', { variant: 'error' })
                setLoading(false)
            })
    }
    const postNDRConfigAdd = (payload) => {
        postGeneric(`${apiConstants.ADD_NDR_EMAIL_CONFIG}`, payload).then(response => {
            enqueueSnackbar('Success', { variant: 'success' })
            reset()
            setReload(reload => reload + 1)
            setLoading(false)
        })
            .catch((err) => {
                console.error(err)
                enqueueSnackbar('Some error occurred', { variant: 'error' })
                setLoading(false)
            })
    }

    const onSubmit = (data) => {
        setLoading(true);
        const emailsArray = data.email.split(',').map(email => email.trim());
        const existingEmails = ndrConfig?.last30DaysNdrReceivedByEmails ?? [];

        const payload = {
            merchantOId: merchantId,
            last30DaysNdrReceivedByEmails: [...existingEmails, ...emailsArray],
            last30DaysNdrReceivedByCCEmails: ["ProshipTechTeam@prozo.com"],
            isLast30DaysNdrEnabled: true,
            last30DaysNdrEmailCronTime: timeVal
        }
        if (ndrConfig) {
            postNDRConfigUpdate(payload)
        } else {
            postNDRConfigAdd(payload)
        }
    }
    const handleCancelOrder = (data) => {
        setDeleteData(data)
        setDeleteConfirm(true)
    }
    const handleDelete = () => {
        const index = ndrConfig?.last30DaysNdrReceivedByEmails?.indexOf(deleteData.email);
        if (index !== -1) {
            ndrConfig?.last30DaysNdrReceivedByEmails.splice(index, 1);
        }
        const payload = {
            merchantOId: merchantId,
            last30DaysNdrReceivedByEmails: [...ndrConfig?.last30DaysNdrReceivedByEmails],
            last30DaysNdrReceivedByCCEmails: ["ProshipTechTeam@prozo.com"],
            isLast30DaysNdrEnabled: true,
            last30DaysNdrEmailCronTime: timeVal
        }
        postNDRConfigUpdate(payload)
    }
    useEffect(() => {
        setLoading(true)
        getGeneric(`${apiConstants.GET_NDR_EMAIL_CONFIG}?merchantOId=${merchantId}`).then((res) => {
            setIsNDRDailyEnabled(res.data?.isDailyEnabled)
            setNDRConfig(res.data);
            setTimeVal(res.data?.last30DaysNdrEmailCronTime)
            setLoading(false)
        }).catch((err) => {
            console.log(err)
            setLoading(false)
        })
    }, [merchantId, reload])
    const toggleEmail = (toggleType) => {
        let payload = {
            merchantOId: merchantId,
            last30DaysNdrReceivedByEmails: [...ndrConfig?.last30DaysNdrReceivedByEmails],
            last30DaysNdrReceivedByCCEmails: ["ProshipTechTeam@prozo.com"],
            isLast30DaysNdrEnabled: toggleType === 'ndr' ? !isNDREnabled : isNDREnabled,
            last30DaysNdrEmailCronTime: timeVal,
            isDailyEnabled: toggleType === 'daily' ? !isNDRDailyEnabled : isNDRDailyEnabled
        }
        postNDRConfigUpdate(payload)
    }

    useEffect(() => {
        setNDREnabled(ndrConfig?.isLast30DaysNdrEnabled)
    }, [ndrConfig])

    const handleSwitchConfirmation = (toggleType) => {
        setSwitchConfirm({ open: true, type: toggleType });
    };
    const handleSwitchAction = () => {
        toggleEmail(switchConfirm.type);
    };

    const formatTime = (time) => {
        if (time instanceof Date) {
            return time.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
        }
        return time;
    }

    return (
        <>
            {(isLoading) && <Loader />}
            <ConfirmDialog
                title=''
                open={deleteConfirm}
                setOpen={setDeleteConfirm}
                onConfirm={() => handleDelete()}>
                Are you sure you want to delete this email ?
            </ConfirmDialog>
            <ConfirmDialog  
                title=''
                open={switchConfirm.open}
                setOpen={() => setSwitchConfirm({ ...switchConfirm, open: false })}
                onConfirm={() => handleSwitchAction()}>
                Are you sure you want to change the email configuration?
            </ConfirmDialog>
            <Box sx={filterBarSx}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                    <Box>
                        <Typography sx={{ fontFamily: FONT, fontSize: SIZE.md, fontWeight: WEIGHT.semibold, color: NAVY }}>NDR Email Configuration</Typography>
                        <Typography sx={{ fontFamily: FONT, fontSize: SIZE.xs, color: SUBTLE, mt: 0.5 }}>Configure NDR email notifications and schedules</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <Tooltip title={isNDRDailyEnabled ? "Disable Daily Email" : "Enable Daily Email"}>
                            <FormControlLabel
                                control={<Switch checked={isNDRDailyEnabled} onChange={() => handleSwitchConfirmation('daily')} disabled={!ndrConfig?.last30DaysNdrReceivedByEmails?.length > 0} sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#4caf50' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#4caf50' } }} />}
                                label={<Typography sx={{ fontFamily: FONT, fontSize: SIZE.xs, color: isNDRDailyEnabled ? '#4caf50' : SUBTLE }}>{isNDRDailyEnabled ? 'Daily On' : 'Daily Off'}</Typography>}
                                labelPlacement="start"
                            />
                        </Tooltip>
                        <Tooltip title={isNDREnabled ? "Disable NDR Emails" : "Enable NDR Emails"}>
                            <FormControlLabel
                                control={<Switch checked={isNDREnabled} onChange={() => handleSwitchConfirmation('ndr')} disabled={!ndrConfig?.last30DaysNdrReceivedByEmails?.length > 0} sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#4caf50' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#4caf50' } }} />}
                                label={<Typography sx={{ fontFamily: FONT, fontSize: SIZE.xs, color: isNDREnabled ? '#4caf50' : SUBTLE }}>{isNDREnabled ? 'NDR On' : 'NDR Off'}</Typography>}
                                labelPlacement="start"
                            />
                        </Tooltip>
                    </Box>
                </Box>
                    <FormProvider methods={methods} onSubmit={handleSubmitForm(onSubmit)}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                                <RHFTextField
                                    name="email"
                                    label="Add Emails *"
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={12} md={2} sx={{ display: 'flex', alignItems: 'center' }}>
                                <LoadingButton loading={isLoading}
                                    type="submit"
                                    variant="contained"
                                    size="small"
                                    sx={primaryBtnSx}
                                >Add
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </FormProvider>
                    <EmailTime postNDRConfigUpdate={postNDRConfigUpdate}
                        postNDRConfigAdd={postNDRConfigAdd}
                        merchantId={merchantId} ndrConfig={ndrConfig}
                        setLoading={setLoading} isNDREnabled={isNDREnabled}
                        setReload={setReload}
                        setTimeVal={setTimeVal}
                    />
                    <Grid item xs={12} sx={{ mt: 1 }}>
                        <Typography sx={{ fontFamily: FONT, fontSize: SIZE.xs, color: SUBTLE }} component="span">Current Email Time: </Typography>
                        <Typography sx={{ fontFamily: FONT, fontSize: SIZE.xs, fontWeight: WEIGHT.semibold, color: isNDREnabled ? NAVY : SUBTLE }} component="span">
                            {isNDREnabled ? (timeVal ? formatTime(timeVal) : 'Not Updated') : "Emails Disabled"}
                        </Typography>
                    </Grid>
            </Box>
            <Grid item xs={12} sx={{ mt: 1 }}>
                <ProzoDataGrid
                    columns={columns}
                    autoHeight={true}
                    rows={ndrConfig?.last30DaysNdrReceivedByEmails?.length > 0 ? ndrConfig?.last30DaysNdrReceivedByEmails?.map((email, index) => ({ id: index, email })) : []}
                    sizePerPage={sizePerPage}
                    setSizePerPage={setSizePerPage}
                    setPage={setPage}
                    page={page}
                    pagination={true}
                    paginationMode='client'
                    rowCount={ndrConfig?.last30DaysNdrReceivedByEmails?.length || 0}
                    getRowId={(row) => row.id}
                />
            </Grid>
        </>
    );
};

export default NDREmailConfig;



const EmailTime = ({ merchantId, ndrConfig, setLoading, setReload, setTimeVal, isNDREnabled }) => {
    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                time: Yup.date()
                    .required('Time is required!')
                    .typeError('Time is required!'),
            })
        ),
        defaultValues: {
            time: ''
        }
    })
    const { handleSubmit, reset } = methods

    const onSubmit = (data) => {
        setLoading(true);
        let payload = {
            merchantOId: merchantId,
            last30DaysNdrReceivedByEmails: [...ndrConfig?.last30DaysNdrReceivedByEmails],
            last30DaysNdrReceivedByCCEmails: ["ProshipTechTeam@prozo.com"],
            isLast30DaysNdrEnabled: true,
            last30DaysNdrEmailCronTime: data.time ? parseTime2(data.time) : ''
        }
        postGeneric(`${apiConstants.UPDATE_NDR_EMAIL_CONFIG}`, payload).then(response => {
            setTimeVal(data.time);
            setReload(reload => reload + 1);
            reset()
        })
            .catch((err) => {
                console.error(err)
                setLoading(false)
            })

    }
    return (
        <>
            <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'row' }}>
                        <RHFDateTimeField mode="time"
                            name="time"
                            label="Update Email Time "
                            size='small'
                            disabled={!ndrConfig?.last30DaysNdrReceivedByEmails?.length > 0 || !isNDREnabled}
                        />
                    </Grid>
                    <Grid item xs={3} sx={{ display: 'flex', alignItems: 'center' }}>
                        <Button size="small"
                            variant="contained"
                            disabled={!ndrConfig?.last30DaysNdrReceivedByEmails?.length > 0 || !isNDREnabled}
                            type="submit"
                            sx={primaryBtnSx}
                        >
                            Update
                        </Button>
                    </Grid>
                </Grid>
            </FormProvider>
        </>
    )
}